// src/components/admin/DataQualityBadge.tsx

import React from 'react';
import { AlertTriangle, CheckCircle, Info, XCircle } from 'lucide-react';

interface DataQualityBadgeProps {
  severity: 'critical' | 'warning' | 'info' | 'healthy';
  tooltip?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function DataQualityBadge({
  severity,
  tooltip,
  size = 'md'
}: DataQualityBadgeProps) {
  const configs = {
    critical: {
      icon: XCircle,
      bgColor: 'bg-red-100',
      textColor: 'text-red-800',
      borderColor: 'border-red-300',
      label: 'Crítico',
    },
    warning: {
      icon: AlertTriangle,
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800',
      borderColor: 'border-yellow-300',
      label: 'Atenção',
    },
    info: {
      icon: Info,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800',
      borderColor: 'border-blue-300',
      label: 'Info',
    },
    healthy: {
      icon: CheckCircle,
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      borderColor: 'border-green-300',
      label: 'OK',
    },
  };

  const config = configs[severity];
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2 py-1',
    lg: 'text-base px-3 py-1.5',
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${config.bgColor} ${config.textColor} ${config.borderColor} ${sizeClasses[size]}`}
      title={tooltip}
    >
      <Icon className={iconSizes[size]} />
      {config.label}
    </span>
  );
}
